import { Label } from '@hakimo-ui/shared/ui-base';
import { VideoCameraIcon } from '@heroicons/react/24/outline';

interface Props {
  cameras?: string[];
}

export function CameraLabels(props: Props) {
  const { cameras = [] } = props;

  if (cameras.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {cameras.map((cameraName, index) => (
        <Label key={index} small>
          <div className="flex items-center gap-1">
            <VideoCameraIcon className="h-4 w-4" />
            <span>{cameraName}</span>
          </div>
        </Label>
      ))}
    </div>
  );
}

export default CameraLabels;
